import React, { useState, useEffect } from 'react';
import { baseImage } from '../constants/categoryconstants';
import { getInactiveLayerNamesFromModel } from '../helpers/modelhelper';

const LureDisplay = (props) => {
    const [images, setImages] = useState();
    const [errors, setErrors] = useState(getInactiveLayerNamesFromModel(props.model));

    useEffect(() => {
        setErrors(updateErrors(props.model));
        renderImages();
    }, [props.model])


    const updateErrors = selectedImages => {
        return getInactiveLayerNamesFromModel(selectedImages);
    }

    const renderImages = () => {
        const { model } = props;
        // check for base layer
        const mainCatImagesToRender = model.filter(img => img.imageUrl !== null).map((category, index) => {
            // if there are no subcategories (category is main category)
            if (category.subCategories.length === 0) {
                return <img
                    src={category.imageUrl}
                    key={`main-category-${index}`}
                    alt={`main category image`}
                    category={category.category}
                    className="lure-display-image"
                    crossOrigin="anonymous"
                />
            }
        });
        const hasSubCats = model.filter(cat => cat.subCategories.length > 0);
        const subCats = [];
        hasSubCats.forEach(cat => {
            cat.subCategories.forEach(sc => subCats.push(sc));
        });
        let subCatsToRender = subCats.filter(item => item.imageUrl !== null).map((sc, index) => {
            return <img
                src={sc.imageUrl}
                key={`sub-category-${index}`}
                alt={`sub category image`}
                category={sc.category}
                className="lure-display-image"
                crossOrigin="anonymous"
            />
        });
        let newImages = mainCatImagesToRender.concat(subCatsToRender);

        newImages.unshift(
            <img
                src={baseImage}
                alt={`base-image`}
                className="lure-display-image"
                key={`base-image`}
                crossOrigin="anonymous"
            />
        );
        setImages(newImages);
    }

    return (
        <div className="col-md-5 col-sm-5 lure-display">
            {errors.length !== 0 ? <div className="alert alert-danger" role="alert">
                <h5>Your lure contains errors. Please correct the following categories:</h5>
                <ul className="lurebuilder-error-list">
                    {errors.map((error, i) => {
                        return <li key={`${error}-error-${i}`}>{error}</li>
                    })}
                </ul>
            </div> : null}
            {images}
        </div>
    )
}

export default LureDisplay;